import { CommonModule } from '@angular/common';
import { NgModule, Optional, SkipSelf } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { ModelSaveHandlers } from 'app/model/handlers/model-save-handlers';
import { SaveHandlers } from './services';
import { customExceptionHandlerProvider } from './services/custom-exception-handler';
import { ErrorDialogComponent } from './services/error-handler';
import { LicenseManager } from 'ag-grid-enterprise';
import { environment } from 'environments/environment';

@NgModule({
  declarations: [ErrorDialogComponent],
  imports: [CommonModule, MatDialogModule, MatButtonModule],
  providers: [
    customExceptionHandlerProvider,
    {
      provide: SaveHandlers,
      useClass: ModelSaveHandlers,
    },
  ],
})
export class CoreModule {
  /**
   * Constructor
   */
  constructor(@Optional() @SkipSelf() parentModule?: CoreModule) {
    // Do not allow multiple injections
    if (parentModule) {
      throw new Error('CoreModule has already been loaded. Import this module in the AppModule only.');
    }
    if (environment.production) {
      LicenseManager.setLicenseKey(environment.agGridLicenseKey);
    }
  }
}
